module.exports = __webpack_public_path__ + "img/tmenu6.46ccdbc7.png";